var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"form-agreement"},[_vm._v(" By submitting this form, you agreed to our website's "),_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v(" privacy policy")]),_vm._v(". ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }